<template>
  <div>
    <a-card :bordered="false">
      <div slot="title" style="border-left: 1px solid #FAAD14;padding-left: 10px">销售任务设置</div>
      <a-form-item label="是否开启销售任务" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-switch
          checked-children="开"
          un-checked-children="关"
          @change="updateServerStatus"
          v-model="serverStatus"></a-switch>
      </a-form-item>
    </a-card>
    <a-card :bordered="false">
      <div slot="title" style="border-left: 1px solid #FAAD14;padding-left: 10px">提现设置
        <a-tooltip
          style="margin-left: 10px"
          placement="top"
          title="分销员提现金额提现到“可提现金额”中"
          :get-popup-container="getPopupContainer"
          :defaultVisible="true"
        >
          <a-icon type="question-circle"/>
        </a-tooltip>
      </div>
      <a-form-model
        style="width: 800px;"
        :label-col="{span:6}"
        :wrapper-col="{span:12}"
        ref="form"
        :model="withdrawalSettingsForm"
        :rules="withdrawalSettingsRules"
      >
        <a-form-model-item
          label="提现次数"
          :required="true"
        >
          每
          <a-form-model-item
            style="display: inline-block;margin-bottom: 0"
            prop="set_dimensionality">
            <a-select
              v-model="withdrawalSettingsForm.set_dimensionality"
              style="width: 100px;"
              placeholder="请选择">
              <a-select-option value="1">日</a-select-option>
              <a-select-option value="2">月</a-select-option>
            </a-select>
          </a-form-model-item>
          最多提现
          <a-form-model-item
            label=""
            style="display: inline-block;margin-bottom: 0"
            :colon="false"
            :required="false"
            prop="set_number">
            <a-input
              v-model="withdrawalSettingsForm.set_number"
              style="width: 120px;"
              type="number"
              placeholder="请输入"
            >
              <span slot="addonAfter">次</span>
            </a-input>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item
          label="提现金额"
          :required="true"
        >
          <a-form-model-item
            v-for="(item,index) in withdrawalSettingsForm.salesTaskWithdrawSetMoneyVoList"
            :key="index"
            style="margin-bottom: 10px"
            :prop="'salesTaskWithdrawSetMoneyVoList.'+index+'.moneyAmount'"
            :rules="withdrawalSettingsRules['salesTaskWithdrawSetMoneyVoList.moneyAmount']"
          >
            <a-input
              v-model="item.moneyAmount"
              style="max-width: 300px;"
              placeholder="请输入金额"
            ></a-input>
            <a-button v-if="index===0" @click="addOptionEvent" style="margin-left: 20px" type="primary">添加</a-button>
            <a-button
              v-else
              style="margin-left: 20px"
              type="danger"
              @click="()=>deleteOptionEvent(index)">删除
            </a-button>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item
          label="  "
          :colon="false"
          :required="false"
        >
          <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
//提现设置
import salesTaskMixins from '@/views/service/serviceProvider/salesTask/salesTaskMixins'

export default {
  name: 'WithdrawalSettings',
  mixins: [salesTaskMixins],
  data() {
    return {
      saveLoading: false,
      withdrawalSettingsForm: {
        salesTaskWithdrawSetMoneyVoList: [{ moneyAmount: undefined }]
      },
      withdrawalSettingsRules: {
        'salesTaskWithdrawSetMoneyVoList.moneyAmount': [
          { required: true, message: '请输入金额', trigger: ['blur', 'change'] }
          , { validator: this.validatorOptionsValue, trigger: ['blur', 'change'] }
        ],
        set_dimensionality: [
          { required: true, message: '请选择周期类型', trigger: ['blur', 'change'] }
        ],
        set_number: [
          { required: true, message: '请输入最大提现次数', trigger: ['blur', 'change'] },
          { pattern: /^[0-9]\d{0,5}$/, message: '提现次数为整数', trigger: ['blur', 'change'] }
        ]
      },
      serverStatus: false //1开启 2关闭
    }
  },
  mounted() {
  },
  created() {
    this.getMerchantServerSwitch()
    this.getWithdrawSetDetails()
  },
  methods: {
    getMerchantServerSwitch() { //查询运营商服务状态
      this.getHttpServices().getUserService().post('merchant/v2/clock/getMerchantServerSwitch', { serverType: 1 })
        .then(res => {
          this.serverStatus = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateServerStatus() { //修改运营商服务状态
      let parms = {
        serverType: 1,
        serverStatus: this.serverStatus ? 1 : 2
      }
      this.getHttpServices().getUserService().post('merchant/v2/clock/updateServerStatus', parms)
        .then(res => {
          let tip = this.serverStatus ? '开启销售任务成功' : '关闭销售任务成功'
          this.$message.success(tip)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getWithdrawSetDetails() { //销售任务提现设置详情查询
      this.getHttpServices().getUserService().post('salesTask/withdrawSet/details', { serverType: 1 })
        .then(res => {
          if (!res.salesTaskWithdrawSetMoneyVoList) {
            res.salesTaskWithdrawSetMoneyVoList = [{ moneyAmount: undefined }]
          }
          res.set_dimensionality = res.set_dimensionality ? res.set_dimensionality.toString() : undefined
          this.withdrawalSettingsForm = res
          this.getLogUtils().logWithTag(this.withdrawalSettingsForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },

    validatorOptionsValue(rule, value, callback) {
      if (/^[1-9][0-9]?$/.test(value)) {
        callback()
      } else {
        callback(new Error('提现金额需为1到99的正整数'))
      }
    },
    deleteOptionEvent(index) {
      this.withdrawalSettingsForm.salesTaskWithdrawSetMoneyVoList = this.withdrawalSettingsForm.salesTaskWithdrawSetMoneyVoList.filter((item, oIndex) => index !== oIndex)
    },
    addOptionEvent() {
      if (this.withdrawalSettingsForm.salesTaskWithdrawSetMoneyVoList.length >= 6) {
        this.$message.error('最多只能添加6个金额')
        return
      }
      this.withdrawalSettingsForm.salesTaskWithdrawSetMoneyVoList.push({ moneyAmount: undefined })
    },
    saveEvent() {
      this.getLogUtils().logWithTag(this.withdrawalSettingsForm)
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },
    submitData() {
      this.saveLoading = true
      let parms = JSON.parse(JSON.stringify(this.withdrawalSettingsForm))
      parms.salesTaskWithdrawSetMoneyVoList.forEach(v => {
        v.money_amount = v.moneyAmount
        delete v.moneyAmount
      })
      parms.salesTaskWithdrawSetMoneyDtoList = parms.salesTaskWithdrawSetMoneyVoList
      parms.set_id = parms.set_id ? parms.set_id : 0
      delete parms.salesTaskWithdrawSetMoneyVoList
      this.getHttpServices().getUserService().post('salesTask/withdrawSet/operating', parms)
        .then(res => {
          this.$message.success('提现设置成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style scoped>
</style>